import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'foundations-theming/utils';
import { LogicGroupNames } from '../../filterQueryFormat/logic/LogicGroup';
import FilterGroupLogicGroupToggle from '../viewer/FilterGroupLogicGroupToggle';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
const ConditionLogicBoxContentContainer = styled.div.withConfig({
  displayName: "ConditionLogicBox__ConditionLogicBoxContentContainer",
  componentId: "makmab-0"
})(["height:22px;"]);
const StyledFormattedMessage = styled(FormattedMessage)(({
  theme,
  isDisabled
}) => Object.assign({
  color: isDisabled ? theme.color['text-core-disabled'] : undefined
}, theme.typography['body-100']));
const ConditionLogicBox = ({
  logicGroupIndex,
  logicOperator,
  showToggle = false,
  showLogicGroupOperatorToggles = false
}) => {
  let logicBoxContent = null;
  if (logicOperator === LogicGroupNames.AND) {
    logicBoxContent = /*#__PURE__*/_jsx(StyledFormattedMessage, {
      isDisabled: showLogicGroupOperatorToggles,
      message: "newCustomerDataFilters.logicOperator.and"
    });
  } else if (logicOperator === LogicGroupNames.OR) {
    logicBoxContent = /*#__PURE__*/_jsx(StyledFormattedMessage, {
      isDisabled: showLogicGroupOperatorToggles,
      message: "newCustomerDataFilters.logicOperator.or"
    });
  }
  return /*#__PURE__*/_jsx(ConditionLogicBoxContentContainer, {
    children: showToggle ? /*#__PURE__*/_jsx(FilterGroupLogicGroupToggle, {
      logicGroupIndex: logicGroupIndex
    }) : /*#__PURE__*/_jsx(Box, {
      paddingInlineEnd: showLogicGroupOperatorToggles ? '300' : '0',
      children: logicBoxContent
    })
  });
};
export default ConditionLogicBox;